import { Injectable } from '@angular/core'
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { AuthManager } from './AuthManager'
import { Observable, of } from 'rxjs'
import { readRouteData } from '../models/Routing'
import { map, switchMap, tap } from 'rxjs/operators'

@Injectable()
export class AuthGuard {
   constructor(public authMgr: AuthManager, public router: Router) {}

   canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
      return this.authMgr.ssoLogin$.pipe(
         switchMap(() => {
            if (!this.authMgr.isAuthenticated()) {
               this.router.navigate(['login'])
               return of(false)
            }

            // given that the role requirement is defined separately from the guard,
            // we could create a separate RoleAuthGuard which has a strong requirement that a RoleQuery is present
            // but this seems enough for now
            let currentRoute = route
            // let data = readRouteData(route);

            // if (!data.requiredRole) {
            //   return of(true);
            // }
            return this.authMgr.getCurrentUser().pipe(
               map((user) => {
                  let retval = true
                  while (retval && currentRoute) {
                     let data = readRouteData(currentRoute)
                     if (data.requiredRole) {
                        retval = this.authMgr.canAccess(user, data.requiredRole)
                     }
                     currentRoute = currentRoute.firstChild
                  }
                  return retval
               }),
               tap((result) => {
                  if (!result) {
                     this.router.navigate(['/'])
                  }
               })
            )
         })
      )
   }
}
